var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbf3a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1854",
    "data-name": "Rectangle 1854"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.7,
    y: 0.7,
    width: 21.6,
    height: 21.6,
    rx: 3.93
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.88,9.84a.46.46,0,0,0-.11-.16L12.34,6.24a.54.54,0,0,0-.16-.1.41.41,0,0,0-.19,0H8.55A1.47,1.47,0,0,0,7.08,7.57v7.86A1.47,1.47,0,0,0,8.55,16.9h5.89a1.47,1.47,0,0,0,1.48-1.47V10A.58.58,0,0,0,15.88,9.84Zm-3.4-2.06,1.76,1.76H12.48Zm2,8.14H8.55a.49.49,0,0,1-.49-.49V7.57a.49.49,0,0,1,.49-.49H11.5V10a.49.49,0,0,0,.49.49h2.95v4.91A.49.49,0,0,1,14.44,15.92Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconDocument);
export default __webpack_public_path__ + "static/media/media-icon-document.5cf7813a204b495c0c71db1f18b8a35b.svg";
export { ForwardRef as ReactComponent };